import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';
import Toggle from 'react-toggle';

import { Link, Redirect} from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

const clientAccessFields = [
  { key: 'real_time_labor', label: 'Usado em Real Time Labor?' },
  { key: 'dashboard', label: 'Usado em Dashboard?' },
  { key: 'sigs_ai', label: 'Usado em SIGS AI?' },
  { key: 'instruction_sheets', label: 'Usado em Fichas de Instrução?' },
  { key: 'reports_hub', label: 'Usado em Central de Relatórios?' },
  { key: 'planejamento', label: 'Usado em Planejamento?' },
  { key: 'segvoos', label: 'Usado em SegVoo?' },
  { key: 'escalas', label: 'Usado em Escalas?' },
  { key: 'portal', label: 'Usado em Cockpit?' },
];

class SigtripUsersAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      staff_list_sigtrip: [],
      staff_list_sigmec: [],
      staff_list_sigtrein: [],
      name: '',
      sigtrip_id: '',
      sigmec_id: '',
      sigtrein_id: '',
      email: '',
      id: '',
      sigrfms: 1,
      sigtrip: 0,
      sigmec: 0,
      sigtrein: 0,
      exam_instructor: 0,
      real_time_labor: 0,
      dashboard: 0,
      sigs_ai: 0,
      instruction_sheets: 0,
      reports_hub: 0,
      planejamento: 0,
      segvoos: 0,
      escalas: 0,
      portal: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigtrip') + '/funcionarios/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_list_sigtrip: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api_sigmec') + '/colaboradores/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({staff_list_sigmec: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api_sigtrein') + '/alunos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({staff_list_sigtrein: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); });
    });
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      sigtrip: this.state.sigtrip,
      sigrfms: 1,
      sigmec: this.state.sigmec,
      sigtrein: this.state.sigtrein,
      exam: 1,
      exam_instructor: this.state.exam_instructor,
      real_time_labor: this.state.real_time_labor,
      dashboard: this.state.dashboard,
      sigs_ai: this.state.sigs_ai,
      instruction_sheets: this.state.instruction_sheets,
      reports_hub: this.state.reports_hub,
      planejamento: this.state.planejamento,
      segvoos: this.state.segvoos,
      escalas: this.state.escalas,
      portal: this.state.portal,
      email: this.state.email,
      name: this.state.name,
      sigtrip_id: this.state.sigtrip_id,
      sigmec_id: this.state.sigmec_id,
      sigtrein_id: this.state.sigtrein_id,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/usuario/completo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/usuario/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar usuário</h3>
      <Link to="/sigtrip/usuarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nome:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>E-mail:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Funcionário SIGTRIP:</label>
            <Select
              className=""
              name="sigtrip_id"
              value={this.state.sigtrip_id}
              searchable={true}
              placeholder={'Selecionar funcionário'}
              onChange={this.handleSelectChange.bind(this, 'sigtrip_id')}
              options={this.state.staff_list_sigtrip}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Funcionário SIGMEC:</label>
            <Select
              className=""
              name="sigmec_id"
              value={this.state.sigmec_id}
              searchable={true}
              placeholder={'Selecionar funcionário'}
              onChange={this.handleSelectChange.bind(this, 'sigmec_id')}
              options={this.state.staff_list_sigmec}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Funcionário SIGTREIN:</label>
            <Select
              className=""
              name="sigtrein_id"
              value={this.state.sigtrein_id}
              searchable={true}
              placeholder={'Selecionar funcionário'}
              onChange={this.handleSelectChange.bind(this, 'sigtrein_id')}
              options={this.state.staff_list_sigtrein}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Usado em SIGTRIP?</label>
            <br/>
            <Toggle
              checked={this.state.sigtrip}
              aria-label='No label tag'
              name="sigtrip"
              onChange={this.handleToggleChange.bind(this, 'sigtrip')} />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em SIGMEC?</label>
              <br/>
              <Toggle
                checked={this.state.sigmec}
                aria-label='No label tag'
                name="sigmec"
                onChange={this.handleToggleChange.bind(this, 'sigmec')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Usado em SIGTREIN?</label>
            <br/>
            <Toggle
              checked={this.state.sigtrein}
              aria-label='No label tag'
              name="sigtrein"
              onChange={this.handleToggleChange.bind(this, 'sigtrein')} />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em Portal do Usuário?</label>
              <br/>
              <Toggle
                checked={true}
                aria-label='No label tag'
                name="sigrfms"
                disabled />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
              <label>Usado em Controle de Prova?</label>
              <br/>
              <Toggle
                checked={true}
                aria-label='No label tag'
                name="exam"
                disabled />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em Controle de Prova (Instrutor)?</label>
              <br/>
              <Toggle
                checked={this.state.exam_instructor}
                aria-label='No label tag'
                name="exam_instructor"
                onChange={this.handleToggleChange.bind(this, 'exam_instructor')} />
          </div>
        </div>
        <div className="row">
          {clientAccessFields.map(function(field) {
            return (
              <div className="col-md-6 form-group" key={field.key}>
                <label>{field.label}</label>
                <br/>
                <Toggle
                  checked={self.state[field.key]}
                  aria-label='No label tag'
                  name={field.key}
                  onChange={self.handleToggleChange.bind(self, field.key)} />
              </div>
            );
          })}
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default SigtripUsersAdd;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersAdd.js